<template>
    <div class="paper" :class="{'paper-small': isSmall}">
        <div v-if="false" class="paper-index">
            <div class="paper-index_left" @click="showLeftImg">
            </div>
            <div class="paper-index_right" @click="showRightImg">
            </div>
            <span>{{(scanSingle && scanSingle.pageNum) || '-- --'}}</span>
        </div>
        <div class="paper-top" :class="statusColor(scanSingle.status)">
            <div v-show="scanSingle.status === 3" @click="deletePaper()" class="paper-delete">
                <div class="paper-delete-content">
                    <img class="paper-delete-icon" src="../../../assets/image/scan/delete-scan-icon.png" alt="">
                </div>
            </div>
            <div class="paper-number" :style="{backgroundColor: statusNumberColor(scanSingle.status)}">
                <span>{{(scanSingle && scanSingle.pageNum) || '-- --'}}</span>
            </div>
            <div class="paper-container">
                <viewImage ref="imageLeft" class="paper-img" :src="leftUrl()" :preview-src-list="[scanSingle[1].url,scanSingle[2].url]"></viewImage>
                <viewImage ref="imageRight" class="paper-img" :src="rightUrl()" :preview-src-list="[scanSingle[2].url,scanSingle[1].url]"></viewImage>
            </div>
            <div class="paper-info">
                <img :src="statusIcon(scanSingle.status)" class="paper-info-icon">
                <span class="paper-info-text">{{statusText(scanSingle.status)}}</span>
                <span v-show="scanSingle.status === 3" @click="showErrMessage(scanSingle)" class="paper-info-err">查看原因</span>
            </div>
        </div>
        <div class="paper-bottom">
            <template v-if="isNormalPaper">
                <div @click="showPaper" v-show="showPaperBtn()" class="err-info-row">
                    <img v-show="!isSmall" class="err-info-row-icon" src="../../../assets/image/classroom/start/start-show-detail-icon.png" alt="">
                    <span class="err-info-row-text">{{isSmall ? '确认试卷' : '手动确认试卷'}}</span>
                </div>
                <div @click="showCode" v-show="showCodeBtn()" class="err-info-row">
                    <img v-show="!isSmall" class="err-info-row-icon" src="../../../assets/image/classroom/start/start-show-detail-icon.png" alt="">
                    <span class="err-info-row-text">{{isSmall ? '输入学号' : '手动输入学号'}}</span>
                </div>
                <div class="student-code-box" v-show="scanSingle.status === 2">
                    <div @click="showCode" class="student-code-part" :class="{'different-class': scanSingle.isBlue, 'normal-class': !scanSingle.isBlue,'small-code': isSmall}">{{scanSingle.studentCode}}</div>
                </div>
            </template>
            <template v-if="!isNormalPaper">
                <div @click="showPaperCode" v-show="!scanSingle.isSubmitCode && scanSingle.failCode === -1" class="err-info-row">
                    <img v-show="!isSmall" class="err-info-row-icon" src="../../../assets/image/classroom/start/start-show-detail-icon.png" alt="">
                    <span class="err-info-row-text">{{isSmall ? '输入编号' : '手动输入编号'}}</span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import viewImage from '../../../components/imageViewer/src/main'
    export default {
        name: "singleScan",
        data () {
            return {
            }
        },
        components: {
            viewImage
        },
        props: ['scanSingle', 'isSmall', 'isNormalPaper', 'paperType'],
        watch: {
        },
        methods: {
            showCodeBtn () {
                if (String(this.paperType) === 'quick' || String(this.paperType) === 'normal') {
                    return this.scanSingle.status === 3 && !this.scanSingle.isSubmitCode && this.scanSingle.needConfirmStudentCode
                }
                return this.scanSingle.status === 3 && !this.scanSingle.isSubmitCode && (this.scanSingle.failCode === 1 || this.scanSingle.failCode === 0 || this.scanSingle.failCode === -1)
            },
            showPaperBtn () {
                if (String(this.paperType) === 'quick' || String(this.paperType) === 'normal') {
                    return this.scanSingle.status === 3 && (this.scanSingle.needConfirmPaperSize || this.scanSingle.needConfirmPaperCode) && !this.scanSingle.isSubmitPaper
                }
                return this.scanSingle.status === 3 && (this.scanSingle.failCode === 0 || this.scanSingle.failCode === -1) && !this.scanSingle.isSubmitPaper
            },
            leftUrl () {
                if (String(this.paperType) === 'personal') {
                    return require('../../../assets/image/scan/personal-scan-left.jpg')
                } else if (String(this.paperType) === 'quick') {
                    return require('../../../assets/image/scan/quick-scan-left.jpg')
                }
                return require('../../../assets/image/scan/normal-scan-left.jpg')
            },
            rightUrl () {
                if (String(this.paperType) === 'personal') {
                    return require('../../../assets/image/scan/personal-scan-right.jpg')
                } else if (String(this.paperType) === 'quick') {
                    return require('../../../assets/image/scan/quick-scan-right.jpg')
                }
                return require('../../../assets/image/scan/normal-scan-right.jpg')
            },
            showRightImg () {
                this.$refs.imageRight.clickHandler()
            },
            showLeftImg () {
                this.$refs.imageLeft.clickHandler()
            },
            // 状态颜色
            statusColor (index) {
                if (index === 0) {
                    return 'paper-top-status1'
                } else if (index === 1) {
                    return 'paper-top-status2'
                }else if (index === 2) {
                    return 'paper-top-status3'
                }else if (index === 3) {
                    return 'paper-top-status4'
                } else {
                    return  ''
                }
            },
            // 文字颜色
            statusNumberColor (index) {
                if (index === 0) {
                    return '#FFE283'
                } else if (index === 1) {
                    return '#AAFFC8'
                }else if (index === 2) {
                    return '#29B9F3'
                }else if (index === 3) {
                    return '#FD6D15'
                } else {
                    return  '#29B9F3'
                }
            },
            statusIcon (index) {
                if (index === 0) {
                    return require('../../../assets/image/scan/upload-icon.png')
                } else if (index === 1) {
                    return require('../../../assets/image/scan/check-icon.png')
                }else if (index === 2) {
                    return require('../../../assets/image/scan/suc-icon.png')
                }else if (index === 3) {
                    return require('../../../assets/image/scan/err-icon.png')
                } else {
                    return  require('../../../assets/image/scan/waite-icon.png')
                }
            },
            // 状态文字
            statusText (index) {
                if (index === 0) {
                    return this.isSmall ? '上传中……' : '试卷上传中……'
                } else if (index === 1) {
                    return this.isSmall ? '校验中……' : '试卷校验中……'
                }else if (index === 2) {
                    return this.isSmall ? '上传成功' : '试卷上传成功'
                }else if (index === 3) {
                    return this.isSmall ? '校验异常' : '试卷校验异常'
                } else {
                    return  this.isSmall ? '等待中……' : '等待中……'
                }
            },
            // 显示失败原因
            showErrMessage (item) {
                this.$notify.error({
                    title: '错误',
                    message: item.isUploadErr ? item.uploadErrMessage : item.message,
                    offset: 50,
                    duration: 3000
                });
            },
            showCode () {
                if (this.showPaperBtn()) {
                    this.$notify.error({
                        title: '提示',
                        message: '请先确认试卷！',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                this.$emit('showCodeDialog', this.scanSingle)
            },
            showPaperCode () {
                this.$emit('showPaperCodeDialog', this.scanSingle)
            },
            showPaper () {
                this.$emit('showPaperDialog', this.scanSingle)
            },
            deletePaper () {
                this.$emit('deletePaper')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .paper{
        margin-left: 22px;
        float: left;
        position: relative;
        overflow: hidden;
        .paper-index{
            position: absolute;
            color:rgba(132,132,132,0.11);
            font-size: 72px;
            text-align: center;
            display: inline-block;
            top: 24px;
            left: 50%;
            z-index: 3;
            transform: translate(-50%, 0);
            .paper-index_left{
                display: inline-block;
                height: 100%;
                opacity: 0;
                position: absolute;
                left: 0;
                top: 0;
                width: 50%;
                cursor: pointer;
                .index_img{
                    width: 100%;
                    height: 100%;
                }
            }
            .paper-index_right{
                display: inline-block;
                height: 100%;
                opacity: 0;
                position: absolute;
                right: 0;
                top: 0;
                width: 50%;
                cursor: pointer;
                .index_img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .paper-top{
            border-radius: 4px;
            width: 240px;
            height: 168px;
            /*background: red;*/
            position: relative;
            border: 3px solid #C7C7C7;
            /*overflow: hidden;*/
            .paper-delete{
                position: absolute;
                right: 0;
                top: 0;
                width:22px;
                height:22px;
                z-index: 2;
                overflow: hidden;
                .paper-delete-content{
                    cursor: pointer;
                    position: absolute;
                    right: -22px;
                    top: -22px;
                    width:44px;
                    height:44px;
                    background: #FD6D15;
                    z-index: 2;
                    border-radius: 50%;
                    overflow: hidden;
                    .paper-delete-icon{
                        width: 25px;
                        position: absolute;
                        left: 1px;
                        bottom: -3px;
                    }
                }
            }
            .paper-number{
                position: absolute;
                left: 0;
                top: 0;
                min-width:25px;
                height:13px;
                z-index: 2;
                box-sizing: border-box;
                padding: 0 5px;
                display: inline-flex;
                align-items: center;
                justify-content: flex-start;
                font-size:12px;
                font-weight:500;
                color:rgba(255,255,255,1);
                overflow: hidden;
                background: #4DADFF;
                line-height: 13px;
                border-radius:0 0 9px 0;
            }
            .paper-container{
                text-align: left;
                position: relative;
                .paper-img{
                    margin-top: 15px;
                    width: 120px;
                    height: 138px;
                }
            }
            .paper-info{
                position: absolute;
                z-index: 2;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #C7C7C7;
                bottom: 0;
                left: 0;
                width: 100%;
                padding-top: 1px;
                box-sizing: border-box;
                .paper-info-icon{
                    font-size: 14px;
                    margin-right: 3px;
                    width: 14px;
                    color: white;
                    margin-top: 1px;
                }
                .paper-info-text{
                    font-size: 14px;
                    line-height: 14px;
                    color: white;
                }
                .paper-info-err{
                    font-size: 12px;
                    margin-left: 18px;
                    cursor: pointer;
                    color: white;
                    text-decoration: underline;
                }
            }
        }
        .paper-top-status1{
            border: 3px solid #FFE283;
            .paper-info{
                background: #FFE283;
                .paper-info-icon{
                    color: #767676;
                }
                .paper-info-text{
                    color: #767676;
                }
            }
        }
        .paper-top-status2{
            border: 3px solid #AAFFC8;
            .paper-info{
                background: #AAFFC8;
                .paper-info-icon{
                    color: #767676;
                }
                .paper-info-text{
                    color: #767676;
                }
            }
        }
        .paper-top-status3{
            border: 3px solid #29B9F3;
            .paper-info{
                background: #29B9F3;
            }
        }
        .paper-top-status4{
            border: 3px solid #FD6D15;
            .paper-info{
                background: #FD6D15;
            }
        }
        .paper-bottom{
            padding: 12px 9px;
            min-height: 42px;
            box-sizing: border-box;
            text-align: left;
            .err-info-row{
                margin-right: 0;
                text-align: left;
                display: inline-block;
                .err-info-row-icon{
                    width: 14px;
                    margin-right: 6px;
                    vertical-align: bottom;
                }
                .err-info-row-text{
                    font-size: 12px;
                    color: #2996F3;
                    text-decoration: underline;
                    cursor: pointer;
                    line-height: 14px;
                }
            }
            .err-info-row:first-child{
               margin-right: 32px;
            }
            .student-code-box{
                text-align: center;
                .student-code-part{
                    display: inline-block;
                    color: #2996F3;
                    border-radius: 10px;
                    padding: 0 8px;
                    box-sizing: border-box;
                    font-size: 14px;
                    cursor: pointer;
                }
                .different-class{
                    background: #4DADFF;
                    color: #FFFFFF;
                }
                .normal-class{
                    border:1px solid rgba(41,150,243,1);
                }
                .small-code{
                    font-size: 12px;
                }
            }
        }
    }
    .paper:nth-child(4n-3){
        margin-left: 0;
    }
    .paper-small:nth-child(4n-3){
        margin-left: 8px;
    }
    .paper-small{
        margin-left: 8px;
        .paper-index{
            font-size: 40px;
            top: 11px;
        }
        .paper-top{
            border-radius: 2px;
            width: 120px;
            height: 84px;
            border: 2px solid #C7C7C7;
            .paper-delete{
                position: absolute;
                right: 0;
                top: 0;
                width:13px;
                height:13px;
                z-index: 2;
                overflow: hidden;
                .paper-delete-content{
                    position: absolute;
                    right: -13px;
                    top: -13px;
                    width:26px;
                    height:26px;
                    background: #FD6D15;
                    z-index: 2;
                    border-radius: 50%;
                    overflow: hidden;
                    cursor: pointer;
                    .paper-delete-icon{
                        width: 13px;
                        position: absolute;
                        left: 2px;
                        bottom: 0;
                    }
                }
            }
            .paper-container{
                .paper-img{
                    width: 54px;
                    /*height: 84px;*/
                    height: 62px;
                    margin-top: 3px;
                    margin-left: 3px;
                }
            }
            .paper-info{
                height: 18px;
                line-height: 18px;
                .paper-info-icon{
                    font-size: 12px;
                    width: 12px;
                }
                .paper-info-text{
                    font-size: 12px;
                }
                .paper-info-err{
                    font-size: 12px;
                    margin-left: 5px;
                }
            }
        }
        .paper-top-status1{
            border: 2px solid #FFE283;
            .paper-info{
                background: #FFE283;
                .paper-info-icon{
                    color: #767676;
                }
                .paper-info-text{
                    color: #767676;
                }
            }
        }
        .paper-top-status2{
            border: 2px solid #AAFFC8;
            .paper-info{
                background: #AAFFC8;
                .paper-info-icon{
                    color: #767676;
                }
                .paper-info-text{
                    color: #767676;
                }
            }
        }
        .paper-top-status3{
            border: 2px solid #29B9F3;
            .paper-info{
                background: #29B9F3;
            }
        }
        .paper-top-status4{
            border: 2px solid #FD6D15;
            .paper-info{
                background: #FD6D15;
            }
        }
        .paper-bottom{
            padding: 10px 0;
            min-height: 38px;
            .err-info-row{
                margin-right: 0;
                .err-info-row-text{
                    font-size: 12px;
                }
            }
            .err-info-row:first-child{
                margin-right: 24px;
            }
        }
    }
    .paper-small:nth-child(8n-7){
        margin-left: 0;
    }
</style>
